import React from 'react';
// template components
import BulletedList from '@nmx/template/dist/componentLibrary/components/BulletedList';
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import SectionContainer from '@nmx/template/dist/componentLibrary/components/SectionContainer';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';

export default () => (
  <SectionContainer
    id='life-insurance-faq-learn-about-variable-settlement-plan'
    backgroundVariant='lightA'
    themeType='lightTheme'>
    <Row align='center'>
      <Col medium={8}>
        <Typography
          component='h2'
          nextElement='typography'
          align='center'>
          Learn About Variable Settlement Plans
        </Typography>
        <Typography nextElement='typography'>
          Variable income plans can only be used to settle variable annuity proceeds. On the one hand, variable
          plans offer you the potential to benefit from market gains. On the other hand, you also assume the
          investment risk.
        </Typography>
        <Typography nextElement='typography'>
          Variable plans do not offer a guaranteed payment amount. Payment amounts depend on the performance of
          the Northwestern Mutual variable investment fund&#40;s&#41; you select. You can choose to receive all or
          part of your proceeds under a variable income plan. Other plans may be available that offer a
          combined variable and fixed plan.
        </Typography>
        <Typography nextElement='typography'>
          Types of Variable Settlement Plans
        </Typography>
        <Typography nextElement='typography'>
          Northwestern Mutual offers three types of variable settlement plans:
        </Typography>
        <Typography
          component='h3'
          nextElement='typography'>
          Period Certain
        </Typography>
        <Typography nextElement='typography'>
          Receive monthly payments for the period you choose in amounts that vary due to market
          fluctuations. Transfers to other available income plans of the entire value may be made without
          charge. Withdrawals of the entire value may be made but charges may apply if the withdrawal is made
          less than five years after the income plan takes effect. Withdrawal changes vary by contract series.
          Time period 5 to 30 years.
        </Typography>
        <Typography
          component='h3'
          nextElement='typography'>
          Single Life Income Plan
        </Typography>
        <Typography nextElement='typography'>
          Receive monthly payments in amounts that vary due to market fluctuations for the
          annuitant&#39;s lifetime or the period you choose, whichever is later. No withdrawals or income plan
          transfers are permitted. Time period 0 to 20 years.
        </Typography>
        <Typography
          component='h3'
          nextElement='typography'>
          Joint and Survivor Life Income Plan
        </Typography>
        <Typography nextElement='typography'>
          Receive principal and earnings in monthly payments that continue as long as you or your joint annuitant is living. Withdrawals from this plan are not allowed during the lifetime of both annuitants. This plan offers five options:
        </Typography>
        <BulletedList
          bulletedListData={[
            {
              bulletText: (<>
                <strong>Joint Life 100&#37; Survivor</strong>
                <BulletedList
                  bulletedListData={[
                    { bulletText: <>Receive monthly payments in amounts that vary due to market fluctuations for the annuitant&#39;s lifetime, the lifetime of the joint annuitant, or for the period you choose, whichever is latest. Upon the death of the first to die, payments continue and are payable to the survivor. No withdrawals or income plan transfers are permitted. Time period is 0 to 20 years.</> },
                  ]}
                  bulletType='disc' />
              </>),
            },
          ]}/>
        <BulletedList
          bulletedListData={[
            {
              bulletText: (<>
                <strong>Joint Life with Two&#45;Thirds to Survivor</strong>
                <BulletedList
                  bulletedListData={[
                    { bulletText: <>Receive monthly payments in amounts that vary due to market fluctuations for the annuitant&#39;s lifetime, the lifetime of the joint annuitant, or the period you choose, whichever is latest. Upon the death of the first to die, payments reduce to two&#45;thirds &#40;2&#47;3&#41; of the monthly payment and are payable to the survivor. No withdrawals or income plan transfers are permitted. Time period is 0 to 20 years.</> },
                  ]}
                  bulletType='disc' />
              </>),
            },
          ]}/>
        <BulletedList
          bulletedListData={[
            {
              bulletText: (<>
                <strong>Joint Life with One&#45;Half to Survivor</strong>
                <BulletedList
                  bulletedListData={[
                    { bulletText: <>Receive monthly payments in amounts that vary due to market fluctuations for the annuitant&#39;s lifetime, the lifetime of the joint annuitant, or the period you choose, whichever is latest. Upon the death of the first to die, payments reduce to one&#45;half &#40;1	&#47;2&#41; of the monthly payment and are payable to the survivor. No withdrawals or income plan transfers are permitted. Time period is 0 to 20 years.</> },
                  ]}
                  bulletType='disc' />
              </>),
            },
          ]}/>
        <BulletedList
          bulletedListData={[
            {
              bulletText: (<>
                <strong>Joint Life with Two&#45;Thirds to Joint Annuitant</strong>
                <BulletedList
                  bulletedListData={[
                    { bulletText: <>Receive monthly payments in amounts that vary due to market fluctuations for the annuitant&#39;s lifetime, the lifetime of the joint annuitant, or the period you choose, whichever is latest. Upon the death of the annuitant, payments reduce to two&#45;thirds &#40;2&#47;3&#41; of the monthly payment and are payable to the joint annuitant, if living, otherwise to the contingent beneficiary. No withdrawals or income plan transfers are permitted. Time period is 0 to 20 years.</> },
                  ]}
                  bulletType='disc' />
              </>),
            },
          ]}/>
        <BulletedList
          bulletedListData={[
            {
              bulletText: (<>
                <strong>Joint Life with One&#45;Half to Joint Survivor</strong>
                <BulletedList
                  bulletedListData={[
                    { bulletText: <>Receive monthly payments in amounts that vary due to market fluctuations for the annuitant&#39;s lifetime, the lifetime of the joint annuitant, or the period you choose, whichever is latest. Upon the death of the first to die, payments reduce to one&#45;half &#40;1&#47;2&#41; of the monthly payment and are payable to the joint annuitant, if living, otherwise to the contingent beneficiary. No withdrawals or income plan transfers are permitted. Time period is 0 to 20 years.</> },
                  ]}
                  bulletType='disc' />
              </>),
            },
          ]}/>
        <Typography nextElement='typography'>
          Who To Consult
        </Typography>
        <Typography
          component='h4'
          nextElement='typography'>
          Decisions concerning a variable income plan should be made within the scope of your total
          financial situation, your tolerance of investment risk and return potential, and with the
          guidance of your representative or tax advisor.
        </Typography>
        <Typography disableBottomPadding>
          For Variable Payment Plans: This description contains a partial summary of contract provisions which
          are explained more completely in the prospectus.
        </Typography>
      </Col>
    </Row>
  </SectionContainer>
);
